import { useState } from "react";
import { MdOutlineCheckCircle, MdRadioButtonUnchecked } from "react-icons/md";
import { useSelector } from "react-redux";
import { formatRupiah } from "../../utils/NumericHelper";
import { isPhone } from "../../utils/PlatformHelper";

const PaymentVA = ({
  groupedPayChans,
  onMakePayment
}) => {

  const [selectedPayChan, setSelectedPayChan] = useState(null)

  const { member, systemProfile, screenSize } = useSelector(state => state.global)

  return (
    <div>
      <div
        className="w-full bg-gray-300 p-1.5 shadow-lg rounded-lg text-center relative p-2 space-y-2"
        style={{
          fontFamily: 'Nunito'
        }}
      >
        <div className="uppercase font-bold">
          Pembayaran Otomatis
        </div>
        <div
          className="bg-blue-100 p-2 px-5 rounded-lg"
          style={{
            fontSize: '14px'
          }}
        >
          <ol className="text-left">
            <li className="p-0">
              Verifikasi Pembayaran Otomatis 24 jam
            </li>
          </ol>
        </div>
      </div>
      <div
        className="space-y-5 p-5 border border-gray-300 rounded-lg shadow-lg"
        style={{
          marginTop: '-15px'
        }}
      >
        <div
          className="space-y-3"
        >
          {groupedPayChans.map(gp => (
            <div
              className="space-y-3"
              style={{
                fontSize: '14px'
              }}
            >
              <div
                className="font-bold text-gray-600"
              >
                {gp.groupChan}
              </div>
              <div
                className="space-y-1.5"
              >
                {gp.channels.map(c => (
                  <button
                    className={
                      "w-full h-[60px] p-3 rounded border flex items-center space-x-5 " +
                      (selectedPayChan && c.code === selectedPayChan.code ? " bg-green-500 border-green-500 text-white " : " hover:shadow-lg hover:border-green-500 ")
                    }
                    onClick={() => setSelectedPayChan(c)}
                  >
                    <div>
                      { 
                        selectedPayChan && c.code === selectedPayChan.code ?
                          (<MdOutlineCheckCircle className="h-5 w-5"/>)
                          :
                          (<MdRadioButtonUnchecked className="h-5 w-5"/>)
                      }
                    </div>
                    <div>
                      <img src={c.icon_url} width="100px"/> 
                    </div> 
                    {!isPhone(screenSize.width) && (
                      <div
                        className="space-y-1"
                      >
                        <div
                          className="text-left"
                          style={{
                            fontSize: '14px'
                          }}
                        >
                          {c.name}
                        </div> 
                        <div>

                        </div>
                      </div>
                    )}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div
          className="py-3 border-t border-b px-5"
        >
          <div 
            className="text-center font-bold"
            style={{
              fontFamily: 'Nunito',
              fontSize: '18px'
            }}
          >
            Detail Jumlah Pembayaran
          </div>
          <div className="flex justify-center">
            <div
              className="w-1/2 space-y-1 py-3"
              style={{
                fontSize: '14px'
              }}
            >
              <div
                className="flex space-x-2"
              >
                <div className="w-28">Pendaftaran</div>
                <div>:</div>
                <div>{formatRupiah(member.biayaPendaftaran)}</div>
              </div>
              <div
                className="flex space-x-2"
              >
                <div className="w-28">Biaya Admin</div>
                <div>:</div>
                <div>{selectedPayChan ? formatRupiah(selectedPayChan.total_fee.flat) : '-' }</div>
              </div>
              <div
                className="flex space-x-2"
              >
                <div className="w-28">Total</div>
                <div>:</div>
                <div>{selectedPayChan ? formatRupiah(member.biayaPendaftaran + selectedPayChan.total_fee.flat) : '-' }</div>
              </div>
            </div>
          </div>
        </div>
        <div
          className=""
        >
          <button
            className="w-full bg-blue-600 hover:bg-blue-500 hover:shadow-lg text-white rounded-lg py-2"
            style={{
              fontSize: '14px'
            }}
            onClick={() => {
              onMakePayment(
                selectedPayChan.code,
                selectedPayChan.name
              )
            }}
          >
            Lanjut Pembayaran
          </button>
        </div>
      </div>

    </div>
  )
}

export default PaymentVA;